import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { EmployeeService } from '../../../../../shared/_services/employee.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-new-benefit',
  templateUrl: './new-benefit.component.html',
  styleUrls: ['./new-benefit.component.scss']
})
export class NewBenefitComponent implements OnInit {

  successMsg: any;
  errorMsg: any;
  statusModal: BsModalRef;
  hotels: any[] = [];
  benefitForm: FormGroup;
  isNewBenefit: boolean;
  benefitId: number;
  private unsubscribe: Subject<void> = new Subject<void>();
  touched: boolean;
  hotel: any;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private location: Location,
    private employeeService: EmployeeService,
    private validationService: ValidationService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "benefit-add") {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
                let status = +this.statusModal.content.srcObject.status;
                this.activateOrDeactivateBenefit(this.statusModal.content.srcObject.id, status);
              } else {
                this.location.back();
                // this.router.navigate(['/members']);
              }
            }
          }
        }
      })
  }

  activateOrDeactivateBenefit(benefitIds, status) {
    this.employeeService.activateOrDeactivateBenefit(benefitIds, status).subscribe(res => {
      if (res.error == 0) {
        this.location.back();
        // this.getBenefitsList(this.p > 0 ? this.p - 1 : this.p);
        // this.allBenefitsSelected = false;
        // this.selectBenefits('all');
      }
    }, err => {
      console.error('Error Activating/Deactivating Benefits: ', err.message);
    })
  }

  getHotelsByHotelChain() {
    this.employeeService.getHotelsByHotelChain().subscribe(res => {
      if (res.error == 0) {
        this.hotels = res.responseObj;
      }
    }, err => {
      console.error('Error while getting hotel list by hotelchain id: ', err.message);
    })
  }

  getBenefitById(benefitId) {
    this.employeeService.getBenefitById(benefitId).subscribe(res => {
      if(res.error == 0) {
        this.initForm(res.responseObj);
      }
    },err => {
      console.error('Error while fetching benefit details by Id: ', err.message);
    })
  }

  templateString(type, info) {
    return `${info} ${type}${info == 1 ? '' : 's'} selected`;
  }

  checkSelection(isChecked?: boolean, id?) {
    const formArray = <FormArray>this.benefitForm.controls['hotels'] as FormArray;
    if (isChecked) {
      formArray.push(new FormControl(id));
    } else {
      if (id == 0) {
      } else {
        let index = formArray.controls.findIndex(x => x.value == id);
        if (index > -1) {
          formArray.removeAt(index);
        }
      }
    }
  }

  addBenefit(isReset) {
    this.benefitForm.value.benefitName = this.benefitForm.value.benefitName.trim();
    this.employeeService.saveOrUpdateBenefit(this.benefitForm.value).subscribe(res => {
      if(res.error == 0) {
        // this.successMsg = res && res.message ? res.message : "Promo added successfully";
        this.successMsg = this.isNewBenefit ? "Benefit has been added successfully" : "Changes made successfully";
        setTimeout(() => {
          this.successMsg = "";
          if (isReset) {
            this.initForm(null);
          } else {
            this.location.back();
          }
      }, 1500);
      }
    },err => {
      this.errorMsg = err && err.message ? err.message : (this.isNewBenefit ? "Error while creating New Benefit" : "Error while updating Benefit");
      setTimeout(() => {
        this.errorMsg = "";
      }, 2000);
      console.error('Error while saving/updating benefit data: ', err.message);
    })

  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this benefit?" : "Are you sure you want to activate this benefit?";
    let title = mode == 0 ? "Deactivate Benefit" : "Activate Benefit";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'benefit-add',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }


  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'benefit-add',
      title: 'Confirm',
      message: this.isNewBenefit ? "Are you sure you want to cancel adding a new benefit?" : "Do you want to cancel modifying the benefit?",
      status: null,
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }

  addHotel(id) {
    let formArray = this.benefitForm.get('hotels') as FormArray;
    formArray.push(new FormControl(id));
  }

  initForm(data) {
    let hotelArr: FormArray = this.fb.array([], this.validationService.minLengthArray(1));
    this.benefitForm = this.fb.group({
      benefitId: [data ? data.benefitId : null],
      benefitName: [data ? data.benefitName : '', [Validators.required, Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      points: [data ? data.points : '', [Validators.required, Validators.max(999999999)]],
      status: [data ? data.status : null],
      hotels: hotelArr
    });
    if(data && data.hotels.length) {
      data.hotels.forEach(hotel => {
        this.addHotel(hotel);
      });
    }
  }

  ngOnInit() {
    this.getHotelsByHotelChain();
    this.route.params.subscribe(params => {
      this.benefitId = +params['id']; // (+) converts string 'id' to a number
      if (this.benefitId) {
        this.isNewBenefit = false;
        this.getBenefitById(this.benefitId);
      } else {
        this.isNewBenefit = true;
      }
      this.initForm(null);
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/new-benefit/new-benefit.component.ts